import React from 'react';
import { HeroSection } from './HeroSection';
import { ProblemSection } from './ProblemSection';
import { AudienceSection } from './AudienceSection';
import { WhatItIs } from './WhatItIs';
import { MechanismSection } from './MechanismSection';
import { WhatsInside } from './WhatsInside';
import { WhyItMatters } from './WhyItMatters';
import { PricingCTA } from './PricingCTA';
import { Footer } from './Footer';
import { FloatingCTA } from './FloatingCTA';
import { TestimonialsSection } from './TestimonialsSection';
import { FAQSection } from './FAQSection';
import { ValueStackSection } from './ValueStackSection';
import { GuaranteeSection } from './GuaranteeSection';
import { CreatorSection } from './CreatorSection';
export function SalesPage() {
  return <div className="min-h-screen w-full bg-[#FAFAF7] text-[#3D3D3D] font-sans selection:bg-[#1B6B3A] selection:text-white" data-id="element-137">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 py-12 md:py-20 lg:py-28 pb-28" data-id="element-138">
        <HeroSection data-id="element-139" />
        <ProblemSection data-id="element-140" />
        <AudienceSection data-id="element-141" />
        <WhatItIs data-id="element-142" />
        <MechanismSection data-id="element-143" />
        <WhatsInside data-id="element-144" />
        <TestimonialsSection data-id="element-145" />
        <WhyItMatters data-id="element-146" />
        <ValueStackSection data-id="element-147" />
        <FAQSection data-id="element-148" />
        <GuaranteeSection data-id="element-149" />
        <PricingCTA data-id="element-150" />
        <CreatorSection data-id="element-151" />
        <Footer data-id="element-152" />
      </div>
      <FloatingCTA data-id="element-153" />
    </div>;
}